// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"40df2393","290":"ff08e433","356":"1188da71","396":"32b27534","716":"a8c592f4"}[chunkId] + ".chunk.js";
};